import React from "react";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const EventListItem = ({ event, isSelected, onSelect }) => {
  const badgeClass =
    event.matchCount > 0
      ? "meta-social-ads__match-badge"
      : "meta-social-ads__match-badge meta-social-ads__match-badge--zero";

  return (
    <div
      className={`meta-social-ads__event-item${isSelected ? " meta-social-ads__event-item--selected" : ""}`}
      onClick={() => onSelect(event.id)}
    >
      <div className="meta-social-ads__event-info">
        <div className="meta-social-ads__event-title">{event.title}</div>
        <div className="meta-social-ads__event-meta">
          {formatDate(event.eventDate)}
          {event.venueName ? ` \u00B7 ${event.venueName}` : ""}
        </div>
      </div>
      <span className={badgeClass}>{event.matchCount}</span>
    </div>
  );
};

export default EventListItem;
